import { DatePart } from "src/app/view-models/utilities/date-part";
import { StoredDatePart } from "../models/stored-utilities/stored-date-part";
import { IStoredMapper } from "./stored-mapper";

/**
 * Mapping class that maps between DatePart view model and database StoredDatePart.
 */
export class DatePartMapper implements IStoredMapper<DatePart, StoredDatePart> {
	/**
	 * Maps a DatePart to a StoredDatePart.
	 * @param datePart The date part data to convert.
	 * @returns A StoredDatePart object.
	 */
	public ToStored(datePart: DatePart): StoredDatePart {
		return {
			Year: datePart.Year,
			Month: datePart.Month,
			Day: datePart.Day,
		};
	}

	/**
	 * Maps a StoredDatePart to a DatePart.
	 * @param storedDatePart The stored date part data to convert.
	 * @returns A DatePart object.
	 */
	public FromStored(storedDatePart: StoredDatePart): DatePart {
		const zeroPad = (num: number) => String(num).padStart(2, '0');
		const dateString: string = `${storedDatePart.Year}-${zeroPad(storedDatePart.Month)}-${zeroPad(storedDatePart.Day)}`;

		return new DatePart(dateString);
	}
}